import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-burger-white",
  "use": "default-burger-white-usage",
  "viewBox": "0 0 30 22",
  "content": "<symbol viewBox=\"0 0 30 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"default-burger-white\"><g fill=\"#fff\" fill-rule=\"evenodd\"><path d=\"M0 9h30v3H0zM0 0h30v3H0zM0 18h30v3H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol